import type { UseIncomingLinksResult } from '../hooks/useIncomingLinks.ts';

import { createPanelDataBridge, type PanelDataBridge } from './createPanelDataBridge.ts';

export type IncomingLinksBridgeData = {
	contentId: string | undefined;
	incomingLinks: UseIncomingLinksResult;
};

export const initialIncomingLinksBridgeData: IncomingLinksBridgeData = {
	contentId: undefined,
	incomingLinks: {
		links: [],
		loading: true,
		loadingMore: false,
		hasNextPage: false,
		endCursor: null,
		loadMore: () => {},
		error: undefined,
	},
};

// BylineConnections is the sole producer. Readers never fetch or hydrate this stream.
const bridge: PanelDataBridge<IncomingLinksBridgeData> = createPanelDataBridge(
	initialIncomingLinksBridgeData,
);

export const publishIncomingLinks: typeof bridge.publish = bridge.publish;
export const clearIncomingLinks: typeof bridge.clear = bridge.clear;
export const useIncomingLinksData: typeof bridge.useValue = bridge.useValue;
export const clearIncomingLinksForTesting: typeof bridge.clearForTesting = bridge.clearForTesting;
